import React, { Component } from "react";

import { Link } from "react-router-dom";

class TravelRequestCreateStep2 extends Component {
  renderStep(no, title, status, active, completed) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1 }}>
        <div
          style={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            background: completed ? "#10B981" : active ? "#1464E9" : "#EEF2F7",
            color: completed || active ? "#fff" : "#334155",
            textAlign: "center",
            lineHeight: "38px",
            fontWeight: 900,
          }}
        >
          {completed ? "✓" : no}
        </div>
        <div>
          <div style={{ fontWeight: 900, color: active ? "#1464E9" : "#334155" }}>{title}</div>
          <div style={{ fontSize: 12, color: completed ? "#10B981" : "#64748B" }}>{status}</div>
        </div>
      </div>
    );
  }

  renderInput(label, value) {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly style={inputStyle} />
      </div>
    );
  }

  render() {
    const schedules = [
      ["19/04/2023", "06:50 - 08:40", "Depart from Kuching International Airport to Kuala Lumpur International Airport"],
      ["19/04/2023", "14:15 - 22:15", "Depart from Kuala Lumpur International Airport to Haneda Airport"],
      ["20/04/2023", "10:25", "Depart from Haneda Airport to Houston Airport"],
      ["21/04/2023", "AM / PM", "Preparation and briefing of Simpleview Summit programme"],
      ["22/04/2023", "AM / PM", "Meeting with Simpleview team for discussion on current CRM issues"],
      ["23/04/2023", "AM / PM", "Attend Simpleview Summit Day 01"],
      ["24/04/2023", "AM / PM", "Attend Simpleview Summit Day 02"],
      ["25/04/2023", "AM / PM", "Attend Simpleview Summit Day 03"],
      ["26/04/2023", "AM / PM", "Attend Simpleview Summit Day 04"],
      ["27/04/2023", "10:20 - 14:00", "Check-out hotel and depart from Houston to Narita"],
      ["28/04/2023", "14:00", "Arrive at Narita International Airport. Annual Leave"],
      ["29/04/2023", "AM / PM", "Transit and own arrangement"],
      ["30/04/2023", "17:30 - 23:55", "Depart from Narita International Airport to Kuala Lumpur International Airport"],
      ["01/05/2023", "07:30 - 09:20", "Depart from Kuala Lumpur International Airport to Kuching International Airport"],
    ];

    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h3 style={{ margin: 0, color: "#0F172A", fontWeight: 900 }}>
            Create Travel Request
          </h3>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Step 2 of 5 · Schedule & Accommodation
          </p>
        </div>

        <div style={stepWrapper}>
          {this.renderStep(1, "Traveler & Trip Details", "Completed", false, true)}
          {this.renderStep(2, "Schedule & Accommodation", "In Progress", true, false)}
          {this.renderStep(3, "Cash Advance", "Pending", false, false)}
          {this.renderStep(4, "Documents", "Pending", false, false)}
          {this.renderStep(5, "Review & Submit", "Pending", false, false)}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 22 }}>
          <div>
            <div style={card}>
              <h4 style={sectionTitle}>Appointment Details / Travel Schedule</h4>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8FAFC" }}>
                    {["Date", "Time", "Scheduled Appointments / Training", "Approving Manager's Comment"].map((h) => (
                      <th key={h} style={thStyle}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {schedules.map((row, index) => (
                    <tr key={index} style={{ borderTop: "1px solid #E5E7EB" }}>
                      <td style={tdStyle}>{row[0]}</td>
                      <td style={tdStyle}>{row[1]}</td>
                      <td style={tdStyle}>{row[2]}</td>
                      <td style={tdStyle}>
                        <input value="" readOnly style={tableInput} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={card}>
              <h4 style={sectionTitle}>Accommodation Details & Other Special Requests</h4>

              <div style={grid3}>
                {this.renderInput("Preferred Hotel / Location", "Cambria Hotel Houston Downtown Convention Center")}
                {this.renderInput("Number of Nights per Person", "7 Nights")}
                {this.renderInput("Breakfast Needed", "No")}
                {this.renderInput("Website", "https://www.cambriahoustondowntown.com/")}
                {this.renderInput("Date Range", "20/04/2023 - 27/04/2023")}
                {this.renderInput("Special Requests / Comments", "No breakfast needed.")}
              </div>
            </div>

            <div style={card}>
              <h4 style={sectionTitle}>Annual or Personal Leave While on Trip</h4>

              <div style={grid3}>
                {this.renderInput("Annual Leave", "Yes")}
                {this.renderInput("Leave Date(s)", "28/04/2023 - 29/04/2023")}
                {this.renderInput("Number of Days", "1½ Day")}
                {this.renderInput("Explanation", "PERSONAL")}
              </div>
            </div>
          </div>

          <div>
            <div style={card}>
              <h4 style={sectionTitle}>Trip Summary</h4>
              {this.renderSideRow("Destination", "Houston, Texas, USA")}
              {this.renderSideRow("Trip Duration", "19/04/2023 - 01/05/2023")}
              {this.renderSideRow("Duration", "13 Days / 11 Nights")}
              {this.renderSideRow("Transportation Mode", "Air")}
              {this.renderSideRow("Purpose", "To attend the Simpleview Summit 2023")}
              {this.renderSideRow("Project Code", "Digitalization of BESarawak & Industry")}
            </div>

            <div style={{ ...card, background: "#EAF3FF", borderColor: "#BFDBFE" }}>
              <h4 style={sectionTitle}>Admin Note</h4>
              <p style={{ color: "#334155", fontSize: 13, lineHeight: "22px", margin: 0 }}>
                Admin will only proceed with the necessary bookings after approval is received.
              </p>
            </div>
          </div>
        </div>

        <div style={footerBar}>
		<Link to="/travel/create/step-1" style={secondaryButtonLink}>
		  ← Back
		</Link>
          <div style={{ display: "flex", gap: 12 }}>
            <button style={secondaryButton}>Save Draft</button>
			<Link to="/travel/create/step-3" style={primaryButtonLink}>
			  Next →
			</Link>
          </div>
        </div>
      </div>
    );
  }

  renderSideRow(label, value) {
    return (
      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, color: "#64748B", fontWeight: 800 }}>{label}</div>
        <div style={{ fontSize: 13, color: "#0F172A", fontWeight: 800, marginTop: 5 }}>
          {value}
        </div>
      </div>
    );
  }
}

const stepWrapper = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 22,
  display: "flex",
  gap: 18,
  marginBottom: 18,
};

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginBottom: 16,
};

const sectionTitle = {
  margin: "0 0 16px",
  color: "#0F172A",
  fontWeight: 900,
};

const thStyle = {
  padding: "10px 12px",
  textAlign: "left",
  fontWeight: 900,
  fontSize: 12,
  color: "#334155",
};

const tdStyle = {
  padding: "9px 12px",
  fontSize: 12,
  color: "#334155",
  verticalAlign: "top",
};

const tableInput = {
  width: "100%",
  height: 30,
  border: "1px solid #E5E7EB",
  borderRadius: 6,
  padding: "0 8px",
  fontSize: 12,
};

const grid3 = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 40,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  color: "#334155",
  background: "#fff",
};

const footerBar = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginTop: 18,
  display: "flex",
  justifyContent: "space-between",
};

const primaryButton = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "12px 28px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "11px 24px",
  fontWeight: 800,
};

const primaryButtonLink = {
  ...primaryButton,
  textDecoration: "none",
  display: "inline-block",
};

const secondaryButtonLink = {
  ...secondaryButton,
  textDecoration: "none",
  display: "inline-block",
};


export default TravelRequestCreateStep2;